import styles from './MultiMain.module.css'
import Question from '../Question'
import MultiOptions from './MultiOptions'
import ButtonAnswer from '../ButtonAnswer'
import ButtonNext from '../ButtonNext'
import AnswerDescription from '../AnswerDescription'
import MenuTools from '../MenuTools'
import ModalResults from '../Modal/ModalResults'
import PopupRepeatedAlternatives from '../Popups/PopupRepeatedAlternatives'
import PopupAlertMessage from '../Popups/PopupAlertMessage'
import { useContext, useEffect, useState } from 'react'
import { Link, useOutletContext } from 'react-router-dom'
import { DataContext } from '../DataContext'

function MultiMain({ 
    question, iconDescription, description, questionNumber, answerDescriptionDisplay, setAnswerDescriptionDisplay, descriptionDisplay, 
    setDescriptionDisplay, questionMulti, setQuestionMulti, optionMulti, optionMultiNumberId, optNum1, optNum2, optNum3, optNum4, optNum5, optNum6
}) {

    const [optionColorStyle] = useState(styles.optionColorMulti)
    const [optionValidateStyle] = useState(styles.optionValidate)
    const [optionInvalidateStyle] = useState(styles.optionInvalidate)
    const [inputColorStyle] = useState(styles.inputMultiOptions)
    const [inputValidateStyle] = useState(styles.inputValidate)
    const [inputInvalidateStyle] = useState(styles.inputInvalidate)
    const [captureValueMulti, setCaptureValueMulti] = useState([])
    const [activePopupRepeatedAlternativesMulti, setActivePopupRepeatedAlternativesMulti] = useState(false) // ativa o componente PopupRepeatedAlternatives na MultiMain
    const [deactiveAnswerBool, setDeactiveAnswerBool] = useState(false) // desativa a palavra 'true' das opções
    
    const { activePopupZeroTimerMultiAlert, setActivePopupZeroTimerMultiAlert, activePageMulti, activePageThreeMulti, questionAnswerButtonNextMultiAndThreeMulti, 
        setQuestionAnswerButtonNextMultiAndThreeMulti, numberRandomPath, setActivePauseTimer } = useOutletContext()

    const { listUnicQuestionsContextLength, listUnicOptionsContextLength, listMultiQuestionsContext, listMultiQuestionsContextLength, listMultiOptionsContextLength, 
        listThreeMultiQuestionsContext, listThreeMultiQuestionsContextLength, listThreeMultiOptionsContextLength } = useContext(DataContext)

    const [itens, setItens] = useState('') // captura os itens corretos
    const [listCorrectAnswers, setListCorrectAnswers] = useState([]) // lista das respostas corretas
    const [answerMultiQuestionAlert, setAnswerMultiQuestionAlert] = useState(false) // ativa o componente PopupAlertMessage

    const [numberPath, setNumberPath] = useState(null) // Gera um número aleatório entre 1 e 4 dependendo dos tipos de questões disponíveis

    useEffect(() => {
        setNumberPath(numberRandomPath())

    }, [numberRandomPath])

    useEffect(() => {
        setQuestionAnswerButtonNextMultiAndThreeMulti(false)

    }, [setQuestionAnswerButtonNextMultiAndThreeMulti])

    useEffect(() => {
        setDeactiveAnswerBool(false) // retorna a palavra 'true' das opções ao estado inicial

    }, [])

    function alertQuestionAnswerButtonNextMultiAndThreeMulti() {
        if (questionAnswerButtonNextMultiAndThreeMulti === false) {
            setAnswerMultiQuestionAlert(true)

        }

        setDeactiveAnswerBool(false) // retorna a palavra 'true' das opções ao estado inicial

    }

    function generateNextQuestion() { // função para gerar uma nova questão para a página Multi
        let listFilterMultiThreeMulti

        if (activePageMulti) {
            listFilterMultiThreeMulti = listMultiQuestionsContext
                .filter(question => question.questionNumber !== questionMulti.questionNumber)

        } else if (activePageThreeMulti) {
            listFilterMultiThreeMulti = listThreeMultiQuestionsContext
                .filter(question => question.questionNumber !== questionMulti.questionNumber)

        }

        (activePageMulti || activePageThreeMulti) && setQuestionMulti(listFilterMultiThreeMulti[Math.floor(Math.random() * listFilterMultiThreeMulti.length)]) // nova questão
        
        setAnswerDescriptionDisplay(styles.invisibleAnswerDescription)
        setDescriptionDisplay(styles.invisibleDescription)

    }

    function numbersThreeFourGenerateNewQuestion() { // se numberPath for igual a 1 ou 2 executará a função 'generateNewQuestionMain()' ao clicar 
        if (listMultiQuestionsContextLength >= 2 && questionAnswerButtonNextMultiAndThreeMulti && (numberPath === 3)) {
            generateNextQuestion()

        } else if (listThreeMultiQuestionsContextLength >= 2 && questionAnswerButtonNextMultiAndThreeMulti && (numberPath === 4)) {
            generateNextQuestion()

        } else if (!questionAnswerButtonNextMultiAndThreeMulti) { // condição: se a questão da página Main não foi respondida
            setAnswerMultiQuestionAlert(true)

        } else if (!questionAnswerButtonNextMultiAndThreeMulti) { // condição: se a questão da página Main não foi respondida
            setAnswerMultiQuestionAlert(true)

        }

        setActivePauseTimer(false) // desativa o pause do Timer ao mudar de página, retorna ao valor inicial

    }

    function ableNextPage() { // função que habilita a próxima rota
        let able = null

        if (listUnicQuestionsContextLength > 0 && listUnicOptionsContextLength > 0 && questionAnswerButtonNextMultiAndThreeMulti) {
        // condição: se tiver questões Main disponíveis e a questão da página Multi for respondida
            able = '/page-main'

        } else if (activePageThreeMulti && listThreeMultiQuestionsContextLength === 1 && listThreeMultiOptionsContextLength === 1 && questionAnswerButtonNextMultiAndThreeMulti) {
            if (listMultiQuestionsContextLength >= 1 && listMultiOptionsContextLength >= 1) {
                able = '/page-multi'

            } else {
                able = '/'

            }

        } else if (listMultiQuestionsContextLength >= 1 && listMultiOptionsContextLength >= 1 && listThreeMultiQuestionsContextLength >= 1 
        && listThreeMultiOptionsContextLength >= 1 && questionAnswerButtonNextMultiAndThreeMulti) {
            if (activePageMulti) {
                able = '/page-three-multi'

            } else if (activePageThreeMulti)
                able = '/page-multi'
            
            else {
                able = '/'

            }

        } else if (listMultiQuestionsContextLength === 1 && listMultiOptionsContextLength === 1 && listThreeMultiQuestionsContextLength === 0
        && listThreeMultiOptionsContextLength === 0 && questionAnswerButtonNextMultiAndThreeMulti) {
            able = '/'

        } else if (listMultiQuestionsContextLength > 1 && listMultiOptionsContextLength > 1 && listThreeMultiQuestionsContextLength === 0 
        && listThreeMultiOptionsContextLength === 0 && questionAnswerButtonNextMultiAndThreeMulti) {
            able = '/page-multi'

        } else if (listMultiQuestionsContextLength === 0 && listMultiOptionsContextLength === 0 && listThreeMultiQuestionsContextLength === 1 
        && listThreeMultiOptionsContextLength === 1 && questionAnswerButtonNextMultiAndThreeMulti) {
            able = '/'
            
        } else if (listMultiQuestionsContextLength === 0 && listMultiOptionsContextLength === 0 && listThreeMultiQuestionsContextLength > 1 
        && listThreeMultiOptionsContextLength > 1 && questionAnswerButtonNextMultiAndThreeMulti) {
            able = '/page-three-multi'
            
        }

        return able

    }

    return (
        <div className={styles.multiMain}>
            <div className={styles.containerTextTitle}>
                <h1 className={styles.textTitle}>Architecture Questions - Randomly</h1>
            </div>
            
            <div className={styles.containerQuestionMenuTools}>
                <Question 
                    question={question}
                    questionNumber={questionNumber}
                    questionMulti={questionMulti}           
                />

                <MenuTools
                    questionMulti={questionMulti} 
                    optionMulti={optionMulti} 
                    optionMultiNumberId={optionMultiNumberId}
                    setAnswerDescriptionDisplay={setAnswerDescriptionDisplay}
                    setDescriptionDisplay={setDescriptionDisplay}               
                />
            
            </div>
        
            <MultiOptions
                optionColorStyle={optionColorStyle}
                inputColorStyle={inputColorStyle}
                setCaptureValueMulti={setCaptureValueMulti}
                captureValueMulti={captureValueMulti}
                optionMulti={optionMulti}
                optNum1={optNum1}
                optNum2={optNum2}
                optNum3={optNum3}
                optNum4={optNum4}
                optNum5={optNum5}
                optNum6={optNum6}
                deactiveAnswerBool={deactiveAnswerBool}
            />

            <ButtonAnswer            
                answerDescriptionDisplay={answerDescriptionDisplay}
                setAnswerDescriptionDisplay={setAnswerDescriptionDisplay}
                descriptionDisplay={descriptionDisplay}
                setDescriptionDisplay={setDescriptionDisplay}
                answer1={questionMulti.correctAnswer1}
                answer2={questionMulti.correctAnswer2}
                answer3={questionMulti.correctAnswer3}
                setListCorrectAnswers={setListCorrectAnswers}
                optionValidateStyle={optionValidateStyle}
                optionInvalidateStyle={optionInvalidateStyle}
                optionColorStyle={optionColorStyle}
                inputColorStyle={inputColorStyle}
                inputValidateStyle={inputValidateStyle}
                inputInvalidateStyle={inputInvalidateStyle}
                captureValueMulti={captureValueMulti}
                optionMulti={optionMulti}
                setQuestionAnswerButtonNextMultiAndThreeMulti={setQuestionAnswerButtonNextMultiAndThreeMulti}
                activePopupRepeatedAlternativesMulti={activePopupRepeatedAlternativesMulti}
                setActivePopupRepeatedAlternativesMulti={setActivePopupRepeatedAlternativesMulti}
                setItens={setItens}
                setDeactiveAnswerBool={setDeactiveAnswerBool}
            />

            <AnswerDescription
                questionMulti={questionMulti}
                listCorrectAnswers={listCorrectAnswers}
                iconDescription={iconDescription}
                description={description}
                answerDescriptionDisplay={answerDescriptionDisplay}
                setAnswerDescriptionDisplay={setAnswerDescriptionDisplay}
                descriptionDisplay={descriptionDisplay}
                setDescriptionDisplay={setDescriptionDisplay}
                itens={itens}             
            />

            <Link
                to={ableNextPage()}
            >
                <ButtonNext 
                    onClick={() => {numbersThreeFourGenerateNewQuestion(); alertQuestionAnswerButtonNextMultiAndThreeMulti()}}
                    questionAnswerButtonNextMultiAndThreeMulti={questionAnswerButtonNextMultiAndThreeMulti}
                />
            </Link>

            <ModalResults />

            {/* PopupRepeatedAlternatives */}
            {activePopupRepeatedAlternativesMulti === true && 
                <PopupRepeatedAlternatives 
                    specificStyles={styles.popupRepeatedMulti} 
                    textPopup={"There are duplicate alternatives and answers. Please, before answering, update the alternatives and answers in the Menu so that each one is unique, and then proceed with your response."}
                    activePopup={setActivePopupRepeatedAlternativesMulti}
                />
            }

            {/* {PopupAlertMessage} */}
            {answerMultiQuestionAlert &&
                <PopupAlertMessage 
                    text="Oops!!! Please answer the question before moving on to the next one!"
                    activePopup={setAnswerMultiQuestionAlert}
                    specificStyles={styles.popupAlertMessage}
                />
            }

            {activePopupZeroTimerMultiAlert && 
                <PopupAlertMessage 
                    text='Oops! Time is up! Please pay attention to the exam time limit.' 
                    specificStyles={styles.popupAlertMessage}
                    activePopup={setActivePopupZeroTimerMultiAlert}
                />
            }
                       
        </div>
    )
}

export default MultiMain;
